import { Button } from '@shared/components';
import { Product } from '@shared/generated/graphql';
import { motion } from 'framer-motion';
import {
  FileText,
  type LucideIcon,
  MapPin,
  Phone,
  Receipt,
  Truck,
} from 'lucide-react';
import { ChatSuggestion } from '../utils/chatSuggestions';

const PRODUCT_ICONS: Partial<Record<Product, LucideIcon>> = {
  [Product.CALLS]: Phone,
  [Product.COVER]: Truck,
  [Product.ORDERS]: FileText,
  [Product.QUOTES]: Receipt,
  [Product.TRACK]: MapPin,
};

const SUGGESTION_STAGGER_SECONDS = 0.05;

type ChatSuggestionsProps = {
  onSelect: (suggestion: ChatSuggestion) => void;
  suggestions: ChatSuggestion[];
};

export function ChatSuggestions({
  onSelect,
  suggestions,
}: ChatSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div
      aria-label="Suggested messages"
      className="flex flex-wrap justify-center gap-2"
      role="group"
    >
      {suggestions.map((suggestion, index) => {
        const ProductIcon = PRODUCT_ICONS[suggestion.product];
        return (
          <motion.div
            key={suggestion.label}
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 4 }}
            transition={{
              delay: index * SUGGESTION_STAGGER_SECONDS,
              duration: 0.2,
              ease: 'easeOut',
            }}
          >
            <Button
              className="!rounded-full"
              icon={ProductIcon ? <ProductIcon size={14} /> : undefined}
              iconPosition="left"
              size="small"
              onPress={() => onSelect(suggestion)}
            >
              {suggestion.label}
            </Button>
          </motion.div>
        );
      })}
    </div>
  );
}
